import * as React from 'react';

import {Body} from 'shells/typography/body';

import styles from './preview.module.css';

type Props = {
    aiGeneratedSubject: string | null | undefined;
    aiGeneratedPreviewText: string | null | undefined;
    aiGeneratedTemplate: string | null | undefined;
};

export function Preview(props: Props) {
    return (
        <div className='background-white full-width full-height br-3 flex flex-dir-col'>
            <div className='border-bottom'>
                <div className='pad-16'>
                    <Body isBold={true} color='dark' size='small'>
                        Subject:{' '}
                    </Body>
                    {props.aiGeneratedSubject}
                </div>
            </div>
            <div className='border-bottom'>
                <div className='pad-16'>
                    <Body isBold={true} color='dark' size='small'>
                        Preview text:{' '}
                    </Body>
                    {props.aiGeneratedPreviewText}
                </div>
            </div>
            <div className={styles['preview-content']}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: props.aiGeneratedTemplate || '<p>No template generated</p>',
                    }}
                />
            </div>
        </div>
    );
}
